class PD_Algolia_SearchBak{constructor(){this.i=["https://cdnjs.cloudflare.com/ajax/libs/algoliasearch/4.24.0/algoliasearch-lite.umd.min.js","https://cdnjs.cloudflare.com/ajax/libs/instantsearch.js/4.72.2/instantsearch.production.min.js"],this.t={},this.h=!1,this.o=null,this.instantsearchHelper=null,this.l=null,this.u=null,this.g=null,this.m=null,this.p=null,this.v=null,this._=null,this.A=null,this.L=null,this.searchResultsEl=null}init(i){var{applicationId:t,searchKey:e,indexName:s,searchInputSelector:n,searchButtonSelector:h,widgetList:r,librariesToLoad:a,searchResultsSelector:o}=i;return this.t=i,this.l=t,this.u=e,this.g=s,this.m=n,this.p=h,this.v=o,this.searchResultsEl=document.querySelector(this.v),this.R("Starting init."),this.S(),Array.isArray(a)&&(this.R("Overriding the default libraries for loading."),this.i=a),this.R("Loading required libraries..."),this.j()?(this.R("Stopping execution because we have added a library and have attached to its onload event."),!1):(this.R("No libraries to load."),this.R("Resetting event listeners on original elements..."),!1===this.D()?(this.R("Error resetting event listeners."),this.I(),!1):(this.R("Done."),this.R("Loading Algolia instance..."),!1===this.N()?(this.R("Error initializing Algolia."),this.I(),!1):(this.R("Done."),this.R("Registering widgets with Algolia..."),!1===this.k(r)?(this.R("Error registering widgets."),this.I(),!1):(this.o.start(),this.R("Done."),this.R("All done, search is ready."),this.h=!0))))}R(t,e="info",i=!1){if(window.location.search.includes("pd_search_log=true")||i){let i="[PD-AlgoliaSearch]";switch(e){case"debug":i+=" (DEBUG)";break;case"error":i+=" (ERROR)";break;case"warn":i+=" (WARN)";break;default:i+=" (INFO)"}console.log(i,t)}}O(){return!1===this.h&&(this.R("Retrying init..."),this.init(this.t),!0)}S(){window.addEventListener("DOMContentLoaded",()=>{window.pd_search.O()}),window.addEventListener("load",()=>{window.pd_search.O()})}j(){return 0<this.i.map(t=>{var i;return!(0<Array.from(document.querySelectorAll("script")).filter(i=>i.src===t).length||((i=document.createElement("script")).onload=()=>{this.R("Library loaded, attempting init again."),this.O()},i.defer=!0,i.src=t,document.head.appendChild(i),0))}).filter(i=>!0===i).length}N(){return"function"==typeof instantsearch&&"function"==typeof algoliasearch&&(this.o=instantsearch({indexName:this.g,searchClient:algoliasearch(this.l,this.u),routing:!0,searchFunction:function(i){""===(window.pd_search.instantsearchHelper=i).state.query?(window.pd_search.searchResultsEl.classList.add("hidden"),window.pd_search.searchResultsEl.style.display="none",window.scrollTo(0,0),document.body.classList.remove("pd-search-open")):(window.pd_search.searchResultsEl.classList.remove("hidden"),window.pd_search.searchResultsEl.style.display="",window.scrollTo(0,0),document.body.classList.add("pd-search-open"),i.search())}}),!0)}D(){if(this._=document.querySelectorAll(this.m),this.A=document.querySelectorAll(this.p),0===this._.length)return!1;this._.forEach(i=>{var t=i.cloneNode(!0);i.parentElement.insertBefore(t,i),i.dataset.pdSearchOrigId=i.id,i.dataset.pdSearchOrigClass=i.className,i.id="",i.className="",i.style.display="none"}),document.querySelectorAll(this.m).forEach(i=>{i.addEventListener("input",i=>{this.L=i.target.value})}),this.A&&(this.A.forEach(i=>{var t=i.cloneNode(!0);i.parentElement.insertBefore(t,i),i.dataset.pdSearchOrigId=i.id,i.dataset.pdSearchOrigClass=i.className,i.id="",i.className="",i.style.display="none"}),document.querySelectorAll(this.m).forEach(i=>{i.addEventListener("click",()=>{this.F(null===this.L?"":this.L)})}))}F(i){return!(!this.instantsearchHelper||void 0===this.instantsearchHelper.setQuery||(this.instantsearchHelper.setQuery(i),0))}I(){this.R("Attempting recovery of the original elements..."),document.querySelectorAll(this.m).forEach((i,t)=>{i.remove()}),this._.forEach(i=>{i.className=i.dataset.pdSearchOrigClass,i.id=i.dataset.pdSearchOrigId,i.style.display=""}),document.querySelectorAll(this.p).forEach((i,t)=>{i.remove()}),this._&&this._.forEach(i=>{i.className=i.dataset.pdSearchOrigClass,i.id=i.dataset.pdSearchOrigId,i.style.display=""}),this.R("Recovery succeeded!")}k(i){return"function"==typeof this.o.addWidgets&&(this.o.addWidgets(i()),!0)}}
class PD_Algolia_Search{constructor(){this.t=["https://cdnjs.cloudflare.com/ajax/libs/algoliasearch/4.24.0/algoliasearch-lite.umd.min.js","https://cdnjs.cloudflare.com/ajax/libs/instantsearch.js/4.72.2/instantsearch.production.min.js"],this.i={},this.o=!1,this.h=null,this.instantsearchHelper=null,this.l=null,this.u=null,this.g=null,this.m=null,this.p=null,this.v=null,this.A=null,this._=null,this.D=null,this.searchResultsEl=null}init(t){var{applicationId:i,searchKey:e,indexName:s,searchInputSelector:n,searchButtonSelector:r,widgetList:a,librariesToLoad:o,searchResultsSelector:h,addToCartMethod:d}=t;return this.i=t,this.l=i,this.u=e,this.g=s,this.m=n,this.p=r,this.v=h,this.L=d,this.searchResultsEl=document.querySelector(this.v),this.R("Starting init."),this.S(),Array.isArray(o)&&(this.R("Overriding the default libraries for loading."),this.t=o),this.R("Loading required libraries..."),this.j()?(this.R("Stopping execution because we have added a library and have attached to its onload event."),!1):(this.R("No libraries to load."),this.R("Resetting event listeners on original elements..."),!1===this.I()?(this.R("Error resetting event listeners."),this.C(),!1):(this.R("Done."),this.R("Loading Algolia instance..."),!1===this.N()?(this.R("Error initializing Algolia."),this.C(),!1):(this.R("Done."),this.R("Registering widgets with Algolia..."),!1===this.O(a)?(this.R("Error registering widgets."),this.C(),!1):(this.h.start(),this.R("Done."),this.R("All done, search is ready."),this.o=!0))))}shopifyAddToCart(t,i=null){t?(i&&(i.innerHTML="Please wait..."),fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:t,quantity:1}]})}).then(t=>{i&&(i.innerHTML="Added to cart!")}).catch(t=>{i?i.innerHTML="Error adding to cart.":alert("Error adding to cart.")})):console.log("[PD] Error adding variant to cart: variantId is not provided!")}R(i,e="info",t=!1){if(window.location.search.includes("pd_search_log=true")||t){let t="[PD-AlgoliaSearch]";switch(e){case"debug":t+=" (DEBUG)";break;case"error":t+=" (ERROR)";break;case"warn":t+=" (WARN)";break;default:t+=" (INFO)"}console.log(t,i)}}T(){return!1===this.o&&(this.R("Retrying init..."),this.init(this.i),!0)}S(){window.addEventListener("DOMContentLoaded",()=>{window.pd_search.T()}),window.addEventListener("load",()=>{window.pd_search.T()})}j(){return 0<this.t.map(i=>{var t;return!(0<Array.from(document.querySelectorAll("script")).filter(t=>t.src===i).length||((t=document.createElement("script")).onload=()=>{this.R("Library loaded, attempting init again."),this.T()},t.defer=!0,t.src=i,document.head.appendChild(t),0))}).filter(t=>!0===t).length}N(){return"function"==typeof instantsearch&&"function"==typeof algoliasearch&&(this.h=instantsearch({indexName:this.g,searchClient:algoliasearch(this.l,this.u),routing:!0,searchFunction:function(t){""===(window.pd_search.instantsearchHelper=t).state.query?(window.pd_search.searchResultsEl.classList.add("hidden"),window.pd_search.searchResultsEl.style.display="none",window.scrollTo(0,0),document.body.classList.remove("pd-search-open")):(window.pd_search.searchResultsEl.classList.remove("hidden"),window.pd_search.searchResultsEl.style.display="",window.scrollTo(0,0),document.body.classList.add("pd-search-open"),t.search())}}),this.h.on("render",()=>{"shopify"===this.L&&document.querySelectorAll(".ais-hit .ais-hit--cart-button").forEach(t=>t.addEventListener("click",t=>{t.preventDefault();var i=document.getElementById(t.target.dataset.formId);if(i)return i=new FormData(i).get("id"),this.shopifyAddToCart(i,t.target),!1;t.target.innerHTML="Error adding to cart.",console.log('Could not find the form ID "'+t.target.dataset.formId+'"')}))}),!0)}I(){if(this.A=document.querySelectorAll(this.m),this._=document.querySelectorAll(this.p),0===this.A.length)return!1;this.A.forEach(t=>{var i=t.cloneNode(!0);t.parentElement.insertBefore(i,t),t.dataset.pdSearchOrigId=t.id,t.dataset.pdSearchOrigClass=t.className,t.id="",t.className="",t.style.display="none"}),document.querySelectorAll(this.m).forEach(t=>{t.addEventListener("input",t=>{this.D=t.target.value})}),this._&&(this._.forEach(t=>{var i=t.cloneNode(!0);t.parentElement.insertBefore(i,t),t.dataset.pdSearchOrigId=t.id,t.dataset.pdSearchOrigClass=t.className,t.id="",t.className="",t.style.display="none"}),document.querySelectorAll(this.m).forEach(t=>{t.addEventListener("click",()=>{this.k(null===this.D?"":this.D)})}))}k(t){return!(!this.instantsearchHelper||void 0===this.instantsearchHelper.setQuery||(this.instantsearchHelper.setQuery(t),0))}C(){this.R("Attempting recovery of the original elements..."),document.querySelectorAll(this.m).forEach((t,i)=>{t.remove()}),this.A.forEach(t=>{t.className=t.dataset.pdSearchOrigClass,t.id=t.dataset.pdSearchOrigId,t.style.display=""}),document.querySelectorAll(this.p).forEach((t,i)=>{t.remove()}),this.A&&this.A.forEach(t=>{t.className=t.dataset.pdSearchOrigClass,t.id=t.dataset.pdSearchOrigId,t.style.display=""}),this.R("Recovery succeeded!")}O(t){return"function"==typeof this.h.addWidgets&&(this.h.addWidgets(t()),!0)}}

/**
 * @typedef PDAlgoliaConfig
 * @type {Object}
 * @property {string} applicationId The ID of the application in Algolia where the index is located. E.g. "A1B2C3D4E5"
 *     in https://www.algolia.com/apps/A1B2C3D4E5/explorer/browse.
 * @property {string} searchKey The Search-only API key for the index. Found at Account Settings -> API keys (not the
 *     settings of the application of index).
 * @property {string} indexName The name of the index to use.
 * @property {string} searchInputSelector The CSS selector of the search input(s). All elements found with the matching
 *     selector will be used. If there are zero elements for the supplied selector, the init will fail. Please create
 *     the element(s) in the HTML or via JS before initializing the class.
 * @property {string} searchButtonSelector The CSS selector of the search button(s). See comments for
 *     searchInputSelector, they all apply here as well.
 * @property {function} widgetList A function which returns an array of all widgets to register in the Algolia instance.
 * @property {string[]} librariesToLoad Override on which libraries to load. Do not use if unsure.
 */

// Initialize - docs for all parameters can be found above.
window.pd_search = new PD_Algolia_Search();
/*let blogs = instantsearch(
	{
		indexName: 'soko_articles',
		searchClient: algoliasearch( 'JY507UH1UW', 'cb34bbe84a386b9781712e8b79439ac2' ),
        searchParameters: {
            hitsPerPage: 3
        }
	}
);*/
window.pd_search.init( {
	applicationId: 'JY507UH1UW',
	searchKey: 'cb34bbe84a386b9781712e8b79439ac2',
	indexName: 'soko_products',
	searchInputSelector: '#pd-main-searchbox-input',
	searchButtonSelector: '#pd-main-searchbox-button',
	searchResultsSelector: '#pd-results',
    addToCartMethod: 'shopify',
	widgetList: () => {
		let mainSearchbox = instantsearch.connectors.connectSearchBox(
			function (
				renderOptions,
				isFirstRender
			) {
				let widgetParams = renderOptions.widgetParams;

				if ( isFirstRender ) {
					document.querySelector( widgetParams.container ).addEventListener(
						'input',
						function ( event ) {
							renderOptions.refine( event.target.value );
						}
					);
				}
			}
		);

		return [
			instantsearch.widgets.configure( {
				hitsPerPage: 16,
			} ),
			mainSearchbox(
				{
					container: '#pd-main-searchbox-input',
					placeholder: 'Search..',
				}
			),
			instantsearch.widgets.pagination(
				{
					container: '#pd-pagination',
					showFirst: false,
					showLast: false,
					cssClasses: {
						root: '',
						list: 'ais-Pagination-list pagination-custom',
						item: 'ais-Pagination-item pagination-custom__num',
						selectedItem: 'ais-Pagination-item--selected active',
						link: 'ais-Pagination-link',
					},
				}
			),
			instantsearch.widgets.hits(
				{
					container: '#pd-results',
					templates: {
						item: function item( hit ) {
							return `
                            <div class="ais-hit ais-product product-grid-item group/product-grid-item" data-handle="${hit.handle}" data-algolia-objectid="${hit.objectID}" data-variant-id="${hit.objectID}" data-product-id="${hit.id}">
    							<div class="product-grid-item__container">
                                     <a data-algolia-objectid="${hit.objectID}" href="/products/${hit.handle}?variant=${hit.objectID}" title="${hit.title}">
                                         <img class="ais-hit--picture" src="${hit.product_image}" alt="${hit.title} - ${hit.variant_title}"/>
                                         ${hit.price < hit.compare_at_price ? 
                                             `<div class="product__badge product__badge--sale">
                                                 SAVE ${Math.floor((((hit.compare_at_price - hit.price)/hit.compare_at_price)*100))}%
                                             </div> ` : ``
                                         } 
                                     </a>
                                     <form id="algolia-add-to-cart-${hit.objectID}" style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
        								 <input type="hidden" name="id" value="${hit.objectID}">
        							 </form>
        							 <p class="ais-hit--cart btn-state-ready stain-button-canvas group/quick-action-button bg-button flex items-center justify-center typography-accent-bold text-a3 
                                               transition-opacity duration-[--enter-animation-duration] pointer-events-auto  w-8 aspect-square min-w-[40px]  min-h-[40px] md:min-h-[48px] 
                                               md:px-5 md:py-3 md:w-full md:aspect-auto">
        								 <button class="ais-hit--cart-button btn-state-ready text-button-contrast group-hover/quick-action-button:text-button-contrast/50 whitespace-nowrap" 
                                                 data-form-id="algolia-add-to-cart-${hit.objectID}">Add to cart</button>
        							 </p>
                                </div>
    							<div class="ais-hit--details product__grid__info text-center">
                                     <!-- Start of Judge.me code -->
                                      ${hit.meta.judgeme !== undefined ? hit.meta.judgeme.badge : ''}
                                    <!-- End of Judge.me code -->

                                    <a data-algolia-objectid="${hit.objectID}" href="/products/${hit.handle}?variant=${hit.objectID}" title="${hit.title}">
        								<div class="ais-hit--details">
                                            <div class="product__grid__title__wrapper">
                                                <p class="ais-hit--subtitle product__grid__title visually-hidden" title="${hit.product_type}${hit.vendor ? ' by ' + hit.vendor : ''}">
            										${instantsearch.highlight( { attribute: 'product_type', hit: hit } )}
            										${hit.vendor ? ' by ' + instantsearch.highlight( {
                        								attribute: 'vendor',
                        								hit: hit
                        							} ) : ''}
            									</p>
                                                <p class="ais-hit--title product__grid__title">
            										${instantsearch.highlight( { attribute: 'title', hit: hit } )}
            									</p>
                                            </div>
                                            
                                            <div class="product__grid__price  product__grid__price--nowrap">
                                                <span style="display: none;" class="product__grid__cutline">Slim Bags 2 Pack</span>
                                                <span class="price ais-hit--price product__grid__price visually-hidden">
                                                    ${hit.price.toLocaleString( 'en-AU', {
                        								style: 'currency',
                        								currency: 'AUD',
                        							} )}
                                                </span>
                                                ${hit.price < hit.compare_at_price ? `
                                                    <span class="price on-sale ais-hit--price">
                                                    ${hit.price.toLocaleString( 'en-AU', {
                        								style: 'currency',
                        								currency: 'AUD',
                        							} )}
                                                    </span>
                                                    <span class="compare-at ais-hit--price">
                                                    ${hit.compare_at_price.toLocaleString( 'en-AU', {
                        								style: 'currency',
                        								currency: 'AUD',
                        							} )}
                                                    </span>
                                                    ` : `
                                                    <span class="price ais-hit--price">
                                                    ${hit.price.toLocaleString( 'en-AU', {
                        								style: 'currency',
                        								currency: 'AUD',
                        							} )}
                                                    </span>
                                                `}
            									<p class="ais-hit--info" style="display: none;">
            										<span class="algolia-sku">
            											${instantsearch.highlight( { attribute: 'sku', hit: hit } )}
            										</span>
            										<span class="algolia-barcode">
            											${instantsearch.highlight( { attribute: 'barcode', hit: hit } )}
            										</span>
            										<span class="algolia-weight">
            											${instantsearch.highlight( { attribute: 'weight', hit: hit } )}
            										</span>
            									</p>
                                            </div>
                                            ${(hit.variants_inventory_count < 1 && hit.inventory_policy == "deny") ?
                                                `<p class="product__grid__price__sold">
                                                        <em>Sold Out</em>
                                                 </p> ` : ``
                                            }
        								</div>
                                    </a>
    							</div>
    						</div>`;
						},
						empty: '<div class="pd-empty-results">No results found matching <strong>{{query}}</strong>.</div>',
					},
					cssClasses: {
						item: 'ais-Hits-item',
						list: 'ais-Hits-list',
					},
				}
			),

            /*instantsearch.widgets.hierarchicalMenu( {
          		container: '#pd-categories',
          		attributes: [
          			'collections',
          		],
          		sortBy: [ 'name:asc' ],
                  limit: 99,
                  searchable: false,
                  showMore: false,
                 	templates: {
          			item: '<a href="javascript:void(0);" class="filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center">' +
                            '<input type="checkbox" class="{{cssClasses.checkbox}}" value="{{label}}" {{#isRefined}}checked{{/isRefined}} />{{label}} <span class="badge badge-secondary badge-pill">{{count}}</span>' +
                            '</a>',
              	},
                  cssClasses: {
                      root: '',
                      list: 'list-group',
                      item: 'filter',
                  },
          	}
          ),*/

          instantsearch.widgets.refinementList( {
          		container: '#pd-brands',
        		attribute: 'vendor',
        		operator: 'or',
        		searchable: false,
                showMore: false,
        		templates: {
                    item: '<a href="javascript:void(0);" class="filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center">' +
                          '<input type="checkbox" class="{{cssClasses.checkbox}}" value="{{label}}" {{#isRefined}}checked{{/isRefined}} />{{label}} <span class="badge badge-secondary badge-pill">{{count}}</span>' +
                          '</a>',
                },
                cssClasses: {
                    root: '',
                    list: 'list-group',
                    item: 'filter',
                },
          	}
          ),

          instantsearch.widgets.refinementList( {
          		container: '#pd-product_type',
        		attribute: 'product_type',
        		operator: 'or',
        		searchable: false,
                showMore: false,
        		templates: {
                    item: '<a href="javascript:void(0);" class="filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center">' +
                          '<input type="checkbox" class="{{cssClasses.checkbox}}" value="{{label}}" {{#isRefined}}checked{{/isRefined}} />{{label}} <span class="badge badge-secondary badge-pill">{{count}}</span>' +
                          '</a>',
                },
                cssClasses: {
                    root: '',
                    list: 'list-group',
                    item: 'filter',
                },
          	}
          ),

          instantsearch.widgets.refinementList( {
          		container: '#pd-inventory_available',
        		attribute: 'inventory_available',
        		operator: 'or',
        		searchable: false,
                showMore: false,
        		templates: {
                item: function(data) {
                  var labelText = (data.label === "true") ? 'In Stock' : 'Out of Stock';
                  return '<a href="javascript:void(0);" class="filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center">' +
                         '<input type="checkbox" class="' + data.cssClasses.checkbox + '" value="' + data.label + '" ' + (data.isRefined ? 'checked' : '') + ' />' +
                         labelText + ' <span class="badge badge-secondary badge-pill">' + data.count + '</span>' +
                         '</a>';
                }
                },
                cssClasses: {
                    root: '',
                    list: 'list-group',
                    item: 'filter',
                },
          	}
          ),

          instantsearch.widgets.rangeSlider( {
          		container: '#pd-price',
        		attribute: 'price',
                tooltips: {
                  format: function(rawValue) {
                    return '$' + Math.round(rawValue).toLocaleString();
                  }
                },
          	}
          ),

          instantsearch.widgets.sortBy( {
          		container: '#pd-sort-by',
    			items: [
                    { value: 'soko_products', label: 'Best selling' },
    				{ value: 'soko_products', label: 'Alphabetically, A-Z' },
    				{ value: 'soko_products', label: 'Alphabetically, Z-A' },
    				{ value: 'soko_products', label: 'Price, low to high' },
    			],
                cssClasses: {
                    root: '',
                    select: 'form-control',
                 },
    			label: 'sort by',
          	}
          )
          
		];
	}
} );

$('.open_pd_search, .close_pd_search, div#search-drawer').click(function() {
    $('body').toggleClass('pd_search_open')
})

$('.open_pd_search, div#search-drawer').click(function() {
    $('#testFocusButton').trigger('click');
})

$('.pd_filter_title').click(function() {
    $(this).parent().toggleClass('open');
    $(this).parent().find('.pd_filter_box').slideToggle()
})

$('div#pd-show-filters').click(function() {
    if ($(this).find('div').text() === 'Hide filters') {
        $(this).find('div').text('Filter');
        $('aside#pd-filters').hide();
        $('div#pd-results').addClass('full')
    } else {
        $(this).find('div').text('Hide filters');
        $('aside#pd-filters').show();
        $('div#pd-results').removeClass('full')
    }
})

$(document).ready(function() {
    // Handle click on the button
    $(document).on('click', 'button[data-pd-search-orig-id="pd-main-searchbox-button"]', function() {
        performSearchRedirect();
    });

    // Handle pressing Enter key on the input field
    $(document).on('keydown', 'input#pd-main-searchbox-input', function(event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            performSearchRedirect();
        }
    });

    // Function to perform the redirect
    function performSearchRedirect() {
        // Get the current URL
        var currentUrl = window.location.href;
        
        // Extract the query string from the current URL
        var queryString = currentUrl.split('?')[1];
        
        // If there is a query string, redirect to /search with the query
        if (queryString) {
            window.location.href = '/search?' + queryString;
        }
    }

    $(document).on('click', '#testFocusButton', function() {
        setTimeout(function() {
            $('#pd-main-searchbox-input').trigger('focus');
        }, 100);
    });
});

if (window.matchMedia('(max-width: 767px)').matches) {
    $('div#pd-show-filters').click()
} 


